import { v4 as uuidv4 } from 'uuid';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ContinueButton extends Vue {
    @Prop({ required: false, default: 'lg' }) buttonSize!: () => string;
    @Prop({ required: false, default: 'Continuar' }) buttonText!: string;
    @Prop({ required: true }) isLoading!: boolean;
    @Prop({ required: true }) isValid!: boolean;
    @Prop({ required: false }) validateFn?: () => Promise<boolean>;

    tooltipTargetId: string = `continue-btn-${uuidv4()}`;

    async onContinue() {
        const isValid = this.validateFn ? await this.validateFn() : this.isValid;
        if (!isValid) {
            this.$bvToast.toast('Por favor, cubra todos los campos requeridos.', {
                autoHideDelay: 10000,
                title: 'Formulario incompleto',
                variant: 'danger'
            });

            this.onInvalidForm();
            return null;
        }

        this.$emit('on:continue');
    }

    onInvalidForm() {
        const existModal = document.querySelector('.modal-dialog');
        if (existModal) {
            const firstErrorInModal = existModal.querySelector('.form__error');
            if (firstErrorInModal) {
                firstErrorInModal.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return null;
            }
        }

        const firstError = document.querySelector('.form__error');
        if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return null;
        }

        const warning = document.querySelector('.alert-warning');
        if (warning) {
            warning.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return null;
        }
    }
}
